import { useRouter } from "next/router"
import { useCallback, useEffect, useState } from "react"
import { WorkItem } from "../machines/work-queue/work-queue-machine"
import { useWorkQueueMachine } from "../machines/machines-context"

export const usePageTransition = () => {
    const router = useRouter()
    const [isTransitioning, setIsTransitioning] = useState(false)
    const [, send] = useWorkQueueMachine()

    useEffect(() => {
        const handleRouteChangeStart = (url: string, { shallow }: { shallow: boolean }) => {
            setIsTransitioning(!shallow)
        }
        const handleRouteChangeComplete = (url: string, { shallow }: { shallow: boolean }) => {
            if (!shallow) setIsTransitioning(false)
        }

        router.events.on("routeChangeStart", handleRouteChangeStart)
        router.events.on("routeChangeComplete", handleRouteChangeComplete)
        router.events.on("routeChangeError", handleRouteChangeComplete)

        return () => {
            router.events.off("routeChangeStart", handleRouteChangeStart)
            router.events.off("routeChangeComplete", handleRouteChangeComplete)
            router.events.off("routeChangeError", handleRouteChangeComplete)
        }
    }, [router])

    useEffect(() => {
        if (isTransitioning) send({ type: "SUSPEND" })
        else send({ type: "RESUME" })
    }, [isTransitioning, send])

    const schedule = useCallback(
        ({ key, action }: WorkItem) => {
            send({ type: "ENQUEUE", key, action })
        },
        [send],
    )

    return {
        isTransitioning,
        schedule,
    }
}
